module.exports = __webpack_public_path__ + "static/img/zhihui-3.526654b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhihui-3.png
// module id = NM7R
// module chunks = 36